module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "garage"
    }
  }, [_c('bc-navbar'), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('h2', {
    staticClass: "page_title"
  }, [_vm._v("\n      My Contacts\n    ")]), _vm._v(" "), _vm._l((_vm.contactData), function(contact) {
    return _c('contact-item', {
      key: contact.id,
      attrs: {
        "contact": contact,
        "isDemo": _vm.isDemoUser
      }
    })
  })], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4637525c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4637525c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/contact/contact.vue
// module id = 772
// module chunks = 0